import Logo from "./Logo.jsx";
import { NAV } from "./Header.jsx";

export default function Footer({ settings, stats, onAdmin }) {
  return (
    <footer className="foot">
      <div className="wrap">
        <div className="foot-grid">
          <div>
            <Logo className="foot-mark" />
            <p className="foot-note">
              {stats.members} Firmen aus {settings.region}.
              <br />
              Gegründet {settings.founded}.
            </p>
            <p className="foot-note foot-about">
              Das Netzwerk für Startups, Gründerinnen, Gründer und Jungunternehmer aus Rapperswil,
              Jona und der Region am oberen Zürichsee.
            </p>
          </div>

          <div>
            <h4>Seite</h4>
            <ul>
              {NAV.map((n) => (
                <li key={n.id}>
                  <a href={`#${n.id}`}>{n.label}</a>
                </li>
              ))}
              <li>
                <a href="#mitmachen">Mitglied werden</a>
              </li>
              <li>
                <a href="#top">Nach oben</a>
              </li>
            </ul>
          </div>

          <div>
            <h4>Netzwerk</h4>
            <ul>
              {settings.linkedin ? (
                <li>
                  <a href={settings.linkedin} target="_blank" rel="noreferrer">
                    LinkedIn-Gruppe
                  </a>
                </li>
              ) : null}
              {settings.contact ? (
                <li>
                  <a href={`mailto:${settings.contact}`}>{settings.contact}</a>
                </li>
              ) : null}
              <li>
                <a href="#mitmachen">Firma anmelden</a>
              </li>
            </ul>
          </div>

          <div>
            <h4>Intern</h4>
            <ul>
              <li>
                <button onClick={onAdmin}>Verwaltung</button>
              </li>
            </ul>
          </div>
        </div>

        <div className="foot-bar">
          <span>
            © {new Date().getFullYear()} {settings.groupName}
          </span>
          <span>{settings.region}</span>
          <span>
            Ein Produkt von{" "}
            <a href="https://www.digitalflux.ch" target="_blank" rel="noopener">
              Digital Flux
            </a>
          </span>
        </div>
      </div>
    </footer>
  );
}
